import React from 'react';
import { useHistory } from 'react-router';

// Types
import { QuickStartGuideItemIDs } from '../QuickStartGuideItems.constants';

// Hooks
import useUpdateQuickStartGuideFlag from '../useUpdateQuickStartGuideFlag';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Utils
import { trackClickQuickStartGuideCTA } from 'Shared/tracking/tracking';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Styles
import './AddIntegrationsStep.scss';

type Props = {
  navigateToList: Function;
};

const AddIntegrationsStep = ({ navigateToList }: Props) => {
  const history = useHistory();
  const step = QuickStartGuideItemIDs.addIntegrations;

  const { handleSkipItem, hasBeenSet } = useUpdateQuickStartGuideFlag();
  const isSet = hasBeenSet(step);
  const { tr } = useTranslation();

  const handleClick = () => {
    trackClickQuickStartGuideCTA(step);
    history.push(PageUrlsConstants.SETTINGS_INTEGRATIONS_PAGE);
  };

  const handleSkipClick = () => {
    handleSkipItem(step);
    navigateToList();
  };

  const baseClassName = 'AddIntegrationsStep';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__button`}>
        <WpButtonGroup stacked>
          <WpButton size="lg" onClick={handleClick}>
            {tr('perform.onboarding.qsg.add_integrations.go_to_page')}
          </WpButton>
          {!isSet && (
            <WpButton size="lg" onClick={handleSkipClick} variant="tertiary">
              {tr('perform.onboarding.qsg.common.skip')}
            </WpButton>
          )}
        </WpButtonGroup>
      </div>
      <WpIllustration
        className={`${baseClassName}__image`}
        src={Illustrations.integrations_ring}
        alt={tr('perform.onboarding.qsg.add_integrations.image_alt')}
      />
    </div>
  );
};
export default AddIntegrationsStep;
